import axios from 'axios';
export default class LoginService {
    loginUsuarios(usuarios) {
        //return axios.get('assets/layout/data/usuarios.json').then(res => res.data.data);
        const url = process.env.VUE_APP_APIURL + `/api/loginempresa`;
        return axios.post(url,usuarios).then(res=>res.data);
    }

}